import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { doSaveMe } from '../actions';
import { BasicForm, InputField, SelectField } from 'react-serial-forms';
import { AGE_RANGE_OPTIONS } from '../constants';
import flattenDeep from 'lodash/array';
import union from 'lodash/array';
import t from 'tcomb-form';
import { EmailRefinement } from '../utils/tcomb-utils';
import CityAutosuggestFactory from '../components/CityAutosuggest';

const AgeRange = t.enums({
  1: 'below 18',
  2: '18 - 24',
  3: '25 - 35',
  4: '35 - 55',
  5: 'over 55'
});

const LocationTransformer = {
  format: (value) => {
    return value;
  },

  parse: (location) => {
    if(location.id) {
      return location.id;
    }
    return location;
  }
};

const UserAccountSchema = t.struct({
  first_name: t.String,
  last_name: t.String,
  email: EmailRefinement,
  age_range: AgeRange,
  //occupation: t.String,
  location: t.maybe(t.Number),
  //notification_on: t.Boolean
});

const formOptions = {
  auto: 'none',
  fields: {
    first_name: {
      error: 'First Name is required',
      attrs: {
        placeholder: 'First Name'
      }
    },
    last_name: {
      error: 'Last name is required',
      attrs: {
        placeholder: 'Last Name'
      }
    },
    email: {
      error: 'Please provide a valid email address',
      type: 'email',
      attrs: {
        placeholder: 'Email'
      }
    },
    age_range: {
      error: 'Please select an age range',
      nullOption: { value: null, text: 'What is your age range?' }
    },
    /*
    occupation : {
      error: 'Please provide your occupation',
      attrs: {
        placeholder: 'What do you do?'
      }
    },
    */
    location: {
      factory: CityAutosuggestFactory,
      transformer: LocationTransformer,
      error: 'Please enter a valid location',
      attrs: {
        placeholder: 'Where do you live'
      }
    },
    notification_on: {}
  }
};


class ProfileAccount extends Component {

  state = {
    formOptions: formOptions,
    formValues: {}
  };

  constructor(props) {
    super(props);
  }

  onFormChange = formValues => {
    this.setState({formValues});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.userInfoForm.getValue();
    if(value) {
      this.props.doSaveMe(value);
      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
    }
  };

  componentWillMount() {
    let { formValues } = this.state;
    const { user } = this.props.auth;

    if(user && user.email) {
      formValues.first_name = user.first_name || null;
      formValues.last_name = user.last_name || null;
      formValues.email = user.email || null;
      formValues.age_range = user.age_range || null;
      formValues.location = user.full_location || null;
      //formValues.notification_on = user.notification_on;
      //formValues.occupation = user.occupation;
    }

    this.setState({ formValues: formValues });
  }

  render() {
    var heading = [<h1 key="heading">My Account</h1>];

    if(!this.props.auth.loggedIn) {
      return <span />;
    }

    return (
      <div className="profile-account">
        {heading}
        <form className="my-account-form" onSubmit={(e)=>{ e.prevenDetault(); }}>
        <t.form.Form ref="userInfoForm" value={this.state.formValues} onChange={this.onFormChange} type={UserAccountSchema} options={this.state.formOptions} />
        <button onClick={this.handleSubmit} className="my-account-submit submitButton button-primary" type="submit">Submit</button>&nbsp;
        <button  className="submitButton " type="reset">Reset</button>&nbsp;
        </form>
      </div>
    );

  }
}


function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  { push, doSaveMe }
)(ProfileAccount);



// WEBPACK FOOTER //
// ./src/containers/ProfileAccount.jsx